import { DateTimeHelper } from 'src/app/core/helper/datetime.helper';
import { AuctionType } from './auction';

export class UserAuction {
    accessLevel: number;
    accessCode: string;
    active: boolean;
    auctionId: number;
    bidAmount: number;
    bidCount: number;
    endDateUtc: string;
    startDateUtc: string;
    hasPreAuth: boolean;
    itemCount: number;
    name: string;
    goal: number;
    ticketCount: number;
    totalRaised: number;
    userId: number;
    logoPath: string;
    hideItemsOnClose: boolean = false;
    hasEnded: boolean;
    currencySymbol: string;
    archived: boolean;
    type: AuctionType

    constructor(listAuction?: Partial<UserAuction>) {
        Object.assign(this, listAuction);

        // ensure that the date is UTC'd
        if (this.startDate != null && !this.startDate.endsWith('Z')) {
            this.startDate += 'Z';
        }
        if (this.endDate != null && !this.endDate.endsWith('Z')) {
            this.endDate += 'Z';
        }

        // format the dates
        this.startDate = DateTimeHelper.formatDate(new Date(this.startDate));
        this.endDate = DateTimeHelper.formatDate(new Date(this.endDate));

        this.hasEnded = (new Date(this.endDate).valueOf() <= new Date().valueOf());

    }

    get endDate() { return this.endDateUtc; }
    set endDate(value: string) { this.endDateUtc = value; }

    get startDate() { return this.startDateUtc; }
    set startDate(value: string) { this.startDateUtc = value; }

    
    get isTestAuction() { return this.type === AuctionType.Demo; }
    get isMarketplace() { return this.type === AuctionType.MarketPlace; }
}
